module.exports = __webpack_public_path__ + "media/new_message_sound.362d86ef.mp3";